import axios from 'axios';

// API URL from environment variable or default
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
console.log("Controle process.env.REACT_APP_API_URL = " + process.env.REACT_APP_API_URL);
console.log("Controle API_URL = " + API_URL);
// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Request interceptor - Add auth token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle token expiration
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    // Handle session expiration or unauthorized access
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      if (error.response.data.message === 'Session expirée. Veuillez vous reconnecter.') {
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;